<template>
  <div>
    <about-personal :hide-nav="true"></about-personal>
    <hr />
    <about-super :hide-nav="true"></about-super>
    <hr />
    <about-retirement :hide-nav="true"></about-retirement>

    <div>
      <hr />
      <div class="page-actions">
        <router-link :to="{name: 'results.contributions'}" class="button results">Results &rarr;</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
